import { InvestmentStatements } from '../../../investment/components/documents/InvestmentStatements';

export default function InvestmentStatementsPage() {
    return <InvestmentStatements />;
}
